import { userStorageKey } from "../constants/values";
import baseAxiosPublic from "./config/baseAxiosPublic";

const postAuthentication = async (email, senha) => {
  const payload = { email, senha };
  var auth = await baseAxiosPublic
    .post("/api/v1/auth", payload)
    .then((response) => decodeToken(response));
  localStorage.setItem(userStorageKey, JSON.stringify(auth));
  return auth;
};

function decodeToken({ data: jwt }) {
  const payload = jwt.split(".")[1];
  const decode = decodeURIComponent(escape(window.atob(payload)));
  const { nome, email, exp } = JSON.parse(decode);

  const userApp = {
    accessToken: jwt,
    nome,
    email,
    exp,
  };
  return { user: userApp };
}

function isAuthenticated() {
  try {
    const token = localStorage.getItem(userStorageKey);
    const { user } = JSON.parse(token);
    if (user) {
      let currentDate = new Date();
      return user.exp * 1000 > currentDate.getTime();
    } else {
      return false;
    }
  } catch {
    return false;
  }
}

function logout() {
  window.location.reload();
  localStorage.clear();
}

function getUserName() {
  try {
    const token = localStorage.getItem(userStorageKey);
    const { user } = JSON.parse(token);
    if (user) {
      return user.nome.split(' ')[0];
    } else {
      return '';
    }
  } catch {
    return 'Usuário';
  }
}


export { postAuthentication, isAuthenticated, logout, getUserName };
